import { render, staticRenderFns } from "./LayoutLoginCard.vue?vue&type=template&id=b274ff28&scoped=true"
import script from "./LayoutLoginCard.vue?vue&type=script&lang=js"
export * from "./LayoutLoginCard.vue?vue&type=script&lang=js"
import style0 from "./LayoutLoginCard.vue?vue&type=style&index=0&id=b274ff28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b274ff28",
  null
  
)

export default component.exports